var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommercialInvoiceActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 15.1729,
    width: 16.5,
    height: 18.6923,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5855 23.1962C24.5855 22.5762 25.1555 22.1362 25.9555 22.1362C26.7755 22.1362 27.3755 22.5862 27.4455 23.2662H28.5355C28.4455 22.2162 27.6655 21.4662 26.5055 21.2862V20.4462H25.6255V21.2562C24.3455 21.3762 23.4955 22.1862 23.4955 23.2962C23.4955 24.2962 24.1855 24.8962 25.7555 25.2362L26.1655 25.3262C27.1855 25.5562 27.5755 25.8462 27.5755 26.4262C27.5755 27.0662 26.9655 27.5462 26.0955 27.5462C25.1755 27.5462 24.5255 27.0262 24.4355 26.2362H23.3055C23.4155 27.4762 24.2955 28.2862 25.6255 28.4262V29.2462H26.5055V28.4262C27.8455 28.2862 28.6955 27.4762 28.6955 26.3762C28.6955 25.2662 28.0755 24.7262 26.4855 24.3562L26.0455 24.2562C24.9855 24.0162 24.5855 23.7162 24.5855 23.1962Z",
    fill: "#FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialInvoiceActive);
export default __webpack_public_path__ + "static/media/Commercial_invoice-active.0821bbb7c205eb18fd9d64b64c3ab47a.svg";
export { ForwardRef as ReactComponent };